<template>
  <div  class="wrap" id='allCheck'>
    <span class="chooseNum zero" v-if="selectedNum==0|| !selectedNum">已选择 <label>0</label> 个</span>
    <!--<span class="chooseNum large" v-else-if="selectedNum>5000">已选择最多 <label>5000</label> 个</span>-->
    <span class="chooseNum" v-else>已选择 <label style="margin: 0 3px;">{{ selectedNum }}</label> 个</span>
    <span class="speLine">|</span>
    <span @click="changeChoose" class="chooseAll" :class="{'choosedAll':checkedAll}">
      <!-- <img v-if="checkedAll" src="../../assets/images/operate/choosed.png"> -->
      <!-- <img v-else src="../../assets/images/operate/choose.png">全选列表 -->
      <i v-if="checkedAll" class="el-icon-check common-theme-color"></i>
      <i v-else class="el-icon-check"></i>&nbsp;全选列表
    </span>
  </div>
</template>

<script>
  export default {
    props:['selectedNum','checkedAll'],
    methods:{
      changeChoose(){
        this.$emit('onClick')
        if(!this.checkedAll){
         window.sa.quick('trackHeatMap',document.querySelector('#allCheck'));
        }
      }
    }
  };
</script>

<style scoped>
.el-icon-check {
  font-weight: bold;
  font-size: 20px;
  margin-top: 6px;
}
.wrap{
  width: 265px;
  height: 100%;
  display: inline-block;
  position: relative;
}
.wrap.largeWrap{
  width: 260px;
}
.wrap .chooseNum {
  width: 145px;
  height: 46px;
  display: inline-block;
  text-align: center;
  color: #555;
  font-size: 14px;
}
.largeWrap .chooseNum.large {
  width: 145px;
}
.wrap .chooseNum label {
  color: #fd5152;
}
.wrap .chooseNum.zero label {
  color: #999;
  margin: 0 5px;
}
.wrap .speLine {
  color: #e5e5e5;
}
.wrap .chooseAll {
  position: absolute;
  top:5px;
  right: 0;
  display: inline-block;
  color: #555;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  height: 36px;
  line-height: 36px;
  width: 100px;
  align-items: center;
  /* border: 1px solid #fff; */
}
.wrap .choosedAll {
  color: var(--theme-color);
  border: 1px solid #ddebeb;
}
.wrap .chooseAll img {
  margin-right: 6px;
  margin-bottom: -2px;
}
.wrap .chooseAll:hover {
  border: 1px solid #ddebeb;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/global/selectedWrap.vue